import React, {useEffect} from 'react';
import {env} from '../../constants/Environment';
import {Table, Icon, Button} from 'semantic-ui-react';
import {useFirestoreConnect, useFirestore} from 'react-redux-firebase'
import {useSelector, useDispatch} from 'react-redux'
import {UsersNavigation} from './Navigation';
import {push} from '../../actions/RouterActions'

const permissions = [
    {
        "name": "lotteries",
        "caption": "Lotterien",
        "actions": ["read", "write"]
    },
    {
        "name": "stories",
        "caption": "Beiträge",
        "actions": ["read", "write"]
    },
    {
        "name": "staticfiles",
        "caption": "Statische Dateien",
        "actions": ["read", "write"]
    },
    {
        "name": "kiosk",
        "caption": "Statische Dateien Kiosk App",
        "actions": ["read", "write"]
    },
    {
        "name": "app",
        "caption": "Statische Dateien Mobile App",
        "actions": ["read", "write"]
    },
    {
        "name": "marketing-displays",
        "caption": "Marketing Displays",
        "actions": ["read", "write"]
    },
    {
        "name": "bookmarker",
        "caption": "Eventticker",
        "actions": ["read"]
    }
];

export default function(props){
    useFirestoreConnect([
        { collection: 'environments/' + env + '/users', doc: props.match.params.userId }
    ])

    useFirestoreConnect([
        { collection: 'environments/' + env + '/users/' + props.match.params.userId + '/permissions', doc: 'cms' }
    ])

    const firestore = useFirestore();
    const dispatch = useDispatch();

    const updatePermission = (permission, action, set) => {
        firestore.collection('environments/' + env + '/users/' + props.match.params.userId + '/permissions').doc('cms').set({
            [permission]: {
                [action]: set
            }
        }, {
            mergeFields: [[permission, action].join('.')]
        })
    };

    let permissionsSet = useSelector(({firestore}) => (
        typeof firestore.data['environments/' + env + '/users/' + props.match.params.userId + '/permissions'] !== 'undefined' && 
        typeof firestore.data['environments/' + env + '/users/' + props.match.params.userId + '/permissions'].cms !== 'undefined' &&
        firestore.data['environments/' + env + '/users/' + props.match.params.userId + '/permissions'].cms !== null
    )?firestore.data['environments/' + env + '/users/' + props.match.params.userId + '/permissions'].cms:{});

    useEffect(() => {
        console.log(props.match.params.userId);
    }, [props.match.params.userId]);

    

    return (
        <UsersNavigation user={props.match.params.userId}>
            <div style={{
                margin: '10px'
            }}>
                <h1><Icon name="users" /> Benutzer bearbeiten <small style={{color: '#999999'}}>{props.match.params.userId}</small></h1>

                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={3}>
                                Berechtigungen
                            </Table.HeaderCell>
                            <Table.HeaderCell  width={3}>
                                
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                {
                    permissions.map((permission) => (
                        <Table.Row>
                            <Table.Cell>
                                {permission.caption}
                            </Table.Cell>
                            <Table.Cell>
                                {
                                    permission.actions.map((action) => {
                                        return (
                                            <div>
                                                <input type="checkbox" value={1} onChange={(e) => {
                                                    updatePermission(permission.name, action, e.target.checked);
                                                }} checked={
                                                    (typeof permissionsSet[permission.name] !== 'undefined' &&  permissionsSet[permission.name][action])?true:null
                                                } /> {action}
                                            </div>
                                        )
                                    })
                                }
                            </Table.Cell>
                        </Table.Row>
                    ))
                }
                    </Table.Body>
                </Table>

                <Button labelPosition="left" icon="caret left" content="Zurück zur Übersicht" onClick={(e) => {
                   dispatch(push('/system/users'));
                }} />
            </div>
        </UsersNavigation>
    )
}